module.exports = "/_next/static/images/gpmBanner-6e564eb6b6cd3b31e45f844d617c1e31.webp";